export default __webpack_public_path__ + "static/media/face4.0553b7cd.png";